export default __webpack_public_path__ + "static/SR USA - Carta de seguridad de color caramelo (en inglés) - Declaración-b5764afe57b23f8bf4b27d11c4d9cb72.pdf";